import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-xs text-subtle" }
const _hoisted_2 = {
  id: "progress-bar",
  class: "relative my-auto h-2 flex-1 overflow-hidden rounded-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-green-100" }, null, -1)
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm font-semibold"
}

import { computed } from 'vue';
import checklistStrings from './checklist-strings';

type Props = {
  section?: string;
  steps: {
    total: number;
    completed: number;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsProgress',
  props: {
    section: null,
    steps: null
  },
  setup(__props: any) {

const props = __props as {
  section?: string;
  steps: {
    total: number;
    completed: number;
  };
};



const progress = computed(() => Math.round(((props.steps.completed / props.steps.total) * 100)));

const containerClass = computed(() => ['flex flex-row items-center gap-2 py-1', props.section ? 'gap-3' : 'max-w-[300px]'].join(' '));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(containerClass))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.steps.completed) + " / " + _toDisplayString(props.steps.total) + " tasks completed ", 1),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "absolute inset-0 rounded-full bg-green-400 opacity-100 transition-all",
        style: _normalizeStyle({ width: `${_unref(progress)}%` })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.section)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(checklistStrings).sections[__props.section]), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})